import React from 'react';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { AlertStatusCard } from '../../UI/Alerts/AlertStatusCard';
import ColumnChartWidget from '../ColumnChartWidget/ColumnChartWidget';

import DateRangePicker from './../../UI/DateRangePicker/DateRangePicker';
import CategorySummaryWidget, { ICategorySummaryWidget } from './../CategorySummaryWidget/CategorySummaryWidget';
import LineChartWidget, { ILineChartWidget } from './../LineChartWidget/LineChartWidget';
import TotalsListWidget, { ITotalsListWidget } from './../TotalsListWidget/TotalsListWidget';

import { ReactComponent as Info } from '../../UI/MessageBox/icons/icon-info-circle.svg';

import Styles from './styles.module.scss';
import { AlertMessage } from './AlertMessage';
import { AlertTitle } from './AlertTitle';

interface IProps {
    onDateChange: (startDate: Date | number, endDate: Date | number) => void;
    categorySummary: ICategorySummaryWidget;
    lineChart: ILineChartWidget;
    totalsList: ITotalsListWidget;
    allVenues?: boolean;
    separateVenueData?: any;
    locale?: any;
    hasPermission?: boolean;
    onAlertClick?: () => void;
}
const AnalyticsDashboardLayout = (props: IProps) => {
    const { hasPermission = true } = props;
    return (
        <div>
            {hasPermission ? (
                <div className={Styles.DateRange}>
                    <DateRangePicker
                        onChange={props.onDateChange}
                        locale={props.locale}
                        // minDate={minDate}
                        // maxDate={maxDate}
                    />
                </div>
            ) : null}
            <div className={Styles.Layout}>
                <div className={Styles.FlexLeft}>
                    <div className={Styles.TotalsWrapper}>
                        <TotalsListWidget
                            {...props.totalsList}
                            items={
                                props.totalsList?.items?.filter(
                                    (item) => item.id !== 'unique_custs' || !props.allVenues,
                                ) ?? []
                            }
                            allVenues={props.allVenues}
                            hasPermission={hasPermission}
                        />
                    </div>
                    <div className={Styles.ChartWrapper}>
                        {props.allVenues ? (
                            <ColumnChartWidget
                                hasPermission={hasPermission}
                                separateVenueData={props.separateVenueData}
                                {...props.lineChart}
                            />
                        ) : (
                            <LineChartWidget {...props.lineChart} />
                        )}
                    </div>
                </div>
                <div className={Styles.FlexRight}>
                    {props.allVenues && hasPermission && (
                        <div
                            style={{
                                marginLeft: '1.25rem',
                            }}
                        >
                            <AlertStatusCard
                                alertProps={{
                                    icon: <Info />,
                                    severity: 'info',
                                    style: {
                                        borderRadius: '12px',
                                    },
                                }}
                                alertMessage={<AlertMessage onClick={props.onAlertClick} />}
                                alertTitle={<AlertTitle />}
                            />
                        </div>
                    )}
                    <div className={Styles.SummaryWrapper}>
                        <CategorySummaryWidget
                            {...props.categorySummary}
                            allVenues={props.allVenues}
                            hasPermission={hasPermission}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AnalyticsDashboardLayout;
